import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/card';
import { Radar } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../utils/axios';
import { AlertaRow } from './AlertasPanel';

export const VigilanciaHomeCard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ visible: false, items: [], total: 0 });

  const load = () => api.get('/vigilancia/home').then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const atender = async (a) => {
    try {
      await api.post(`/vigilancia/alertas/${a.id}/atender`);
      toast.success('Alerta atendida');
      load();
    } catch { toast.error('No se pudo atender la alerta'); }
  };

  if (!data.visible || !data.total) return null;
  return (
    <Card className="vig-scope mb-8 p-5 border-2 border-rose-200 bg-rose-50" data-testid="home-vigilancia-alertas">
      <div className="flex items-start gap-3">
        <div className="p-2.5 bg-rose-600 rounded-lg shrink-0"><Radar className="h-6 w-6 text-white" /></div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-bold text-rose-800" data-testid="home-vigilancia-titulo">
            {data.total} alerta{data.total > 1 ? 's' : ''} en Vigilancia de Cuentas
          </h3>
          <p className="text-sm text-rose-700 mb-3">Cuentas vigiladas que bajaron del umbral configurado.</p>
          <div className="space-y-1.5 max-h-60 overflow-y-auto">
            {data.items.map((a) => (
              <AlertaRow key={a.id} a={a} prefix="home-vig" onAtender={atender} onVer={() => navigate('/m/operaciones/vigilancia')} />
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default VigilanciaHomeCard;
